import { Injectable } from "@angular/core";

@Injectable({
	providedIn: "root",
})
export class PermissionService {

    functionalPermissionList: string[];
    productPermissionList: string[];

	constructor() {}

    getFunctionalAccessList(){
        let localStorageFuncPermission = localStorage.getItem("getFunctionalPermissions")
        if(localStorageFuncPermission){
            let parsedList = JSON.parse(localStorageFuncPermission);
            return eval(parsedList)
        } else {
            return [];
        }
    }
    getProductsAccessList(){
        let localStorageProductPermission = localStorage.getItem("getProductPermissions")
        if(localStorageProductPermission){
            let parsedList = JSON.parse(localStorageProductPermission);
            return eval(parsedList)
        } else {
            return [];
        }
    }
    
    getUserRoleList(){
        let localStorageUserRole = localStorage.getItem("getUserRole")
        if(localStorageUserRole){
            let parsedList = JSON.parse(localStorageUserRole);
            return eval(parsedList)
        } else {
            return [];
        }
    }

	getFunctionalAccess(functionName: string){
        let localStorageFuncPermission = localStorage.getItem("getFunctionalPermissions")
        if(localStorageFuncPermission){
            let parsedList = JSON.parse(localStorageFuncPermission);
            this.functionalPermissionList = eval(parsedList);
        }

        let functionIsAllowed =  this.functionalPermissionList.find((x) => x == functionName);
        if(functionIsAllowed) return true;
        else return false;
    }

	getProductAccess(functionName: string){
        let localStorageProductPermission = localStorage.getItem("getProductPermissions")
        if(localStorageProductPermission){
            let parsedList = JSON.parse(localStorageProductPermission);
            this.productPermissionList = eval(parsedList);
        }

        let isAllowed =  this.productPermissionList.find((x) => x == functionName);
        if(isAllowed) return true;
        else return false;
    }
}
